import { CaretDownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
const ButtonLink = styled.button``;

const classNav = (navigate) => {
    return {
        items: [
            {
                key: 'teaching-heritage',
                label: <a onClick={() => navigate('/teaching-heritage')}>1. Teaching Heritage Language Learners</a>
            },
            {
                key: 'differentiation',
                label: <a onClick={() => navigate('/differentiation')}>2. Differentiation</a>
            },
            {
                key: 'class-passwords',
                label: <a onClick={() => navigate('/class-passwords')}>3. Class Passwords/ Contraseñas</a>
            },
            {
                key: 'play',
                label: <a>4. Play</a>
            },
            {
                key: 'critical-language-acquisition',
                label: <a>5. Critical Language Acquisition</a>
            },
            {
                key: 'critical-language-awareness',
                label: <a>6. Critical Language Awareness</a>
            },
            {
                key: 'focus-meaning-form',
                label: <a>7. Focus on Meaning and on Form</a>
            },
            {
                key: 'primacy-recency-effect',
                label: <a>8. The Primacy Recency Effect</a>
            },
            {
                key: 'lowering-affective-filter',
                label: <a>9. Lowering the Affective Filter</a>
            },
            {
                key: 'listening-to-reading',
                label: <a>10. From Listening to Reading</a>
            },
            {
                key: 'speaking-to-writing',
                label: <a>11. From Speaking to Writing</a>
            },
            {
                key: 'jamboard-anecdotas',
                label: <a>12. Jamboard & Anécdotas Graphic organizers</a>
            },
            {
                key: 'integrated-performance-assessments',
                label: <a>13. Integrated Performance Assessments</a>
            },
            {
                key: 'grasps',
                label: <a>14. GRASPS</a>
            },
            {
                key: 'interpretative-communication',
                label: <a>15. Interpretative Communication Activities</a>
            },
            {
                key: 'interpersonal-communication',
                label: <a>16. Interpersonal Communication Activities</a>
            },
            {
                key: 'presentational-communication',
                label: <a>17. Presentational Communication Activities</a>
            },
            {
                key: 'integrating-three-modes',
                label: <a>18. Integrating the three modes of communication</a>
            },
            {
                key: 'heritage-language',
                label: <a onClick={() => navigate('/heritage-language')}>19. Heritage Language Teaching Objectives</a>
            },
            {
                key: 'data-driven',
                label: <a onClick={() => navigate('/data-driven')}>20. The data driven instructor</a>
            }
        ]
    };
};

const Index = ({ }) => {
    const navigate = useNavigate();
    return (
        <Dropdown menu={{ items: classNav(navigate) }} trigger={['click']} className="mobSrchLink" style={{ left: 'initial' }}>
            <ButtonLink onClick={e => e.preventDefault()}>
                Search
                <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
            </ButtonLink>
        </Dropdown>
    );
};


export default Index;
